import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import { Text } from '@mercator-gcp/grout';

interface Props {
  title: string;
  children: ReactNode;
}

const styles = {
  header: {
    mb: 'padding_16',
  },
};

export const AccountSettingsSection = ({ title, children }: Props) => {
  return (
    <Box>
      <Text.H2 sx={styles.header}>{title}</Text.H2>
      {children}
    </Box>
  );
};
